<template>
  <router-view />
</template>

<script>
import { unRegisterMixin } from '@/mixin/storeGenerator';

export default {
  name: 'WrapperOrderBooks',
  mixins: [unRegisterMixin],
  data() {
    return {
      moduleName: 'orderBooksModule',
    };
  },
};
</script>
